import React from 'react';
import BookingDetails from './BookingDetails';

const BookingCard = ({ 
  booking, 
  actionLoading, 
  onEditDates, 
  onCancel, 
  onAccept,
  currentUserId 
}) => {
  return (
    <BookingDetails
      booking={booking}
      actionLoading={actionLoading}
      onEditDates={onEditDates}
      onCancel={onCancel}
      onAccept={onAccept}
      currentUserId={currentUserId}
      showCloseButton={false}
    />
  );
};

export default BookingCard;
